import {ref} from '@vue/composition-api'

const selectedSidebar = ref(undefined)

function openSidebar(id){
  selectedSidebar.value = id
}
function closeSidebar(){
  selectedSidebar.value = undefined
}

function install (Vue) {
  Vue.prototype.$selectedSidebar = selectedSidebar
  Vue.prototype.$openSidebar = openSidebar
  Vue.prototype.$closeSidebar = closeSidebar
}


export default {
  install
}

